(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OffDaySearch', OffDaySearch);

    OffDaySearch.$inject = ['$resource', 'ENV'];

    function OffDaySearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/off-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
